module.exports = __webpack_public_path__ + "img/ai_help01_img_03.7d7950c8.png";